<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        @on-add="showFormModalDialog"
      />
    </div>
    <ConfigDialog
      :id="entityId"
      :visible="modalForm"
      :width="500"
      :action="url"
      @on-close="onModalClose"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import ConfigDialog from './dialog/config-dialog'
export default {
  name: 'ServerConfig',
  components: {
    TableWrapper, ConfigDialog
  },
  data() {
    return {
      modalForm: false,
      entityId: 0,
      modCount: 0,
      url: this.$config.apiContextPath + '/config'
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    namespaceOptions() {
      return [
        { label: '车库配置', value: 'NS_PARKING' },
        { label: '车辆配置', value: 'NS_VEHICLE' },
        { label: '会员配置', value: 'NS_MEMBER' },
        { label: '产品配置', value: 'NS_PRODUCT' },
        { label: '终端配置', value: 'NS_AGENT' },
        { label: '系统配置', value: 'NS_SYSTEM' }
      ]
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '字典参数', placeholder: '请输入字典参数..', name: 'key', width: 'auto', type: 'input' },
          { label: '字典域', placeholder: '请输入字典域...', name: 'namespace', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '字典域', align: 'left', key: 'namespace', sortable: true, ellipsis: true, tooltip: true, width: 120,
          render: (h, params) => {
            return h('span', {}, this.getNamespaceLabel(params.row.namespace) || '---')
          }
        },
        { title: '参数名', align: 'left', key: 'description', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.description || '---')
          }
        },
        { title: '参数Key', align: 'left', key: 'key', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.key || '---')
          }
        },
        { title: '参数值', align: 'left', key: 'value', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.value || '---')
          }
        },

        { title: '创建时间', align: 'center', sortable: true, width: 160, ellipsis: true, tooltip: true, key: 'createTime',
          render: (h, params) => {
            return h('span', {}, params.row.createTime || '---')
          }
        },
        { title: '更新时间', align: 'center', sortable: true, width: 160, ellipsis: true, tooltip: true, key: 'lastModifiedTime',
          render: (h, params) => {
            return h('span', {}, params.row.lastModifiedTime || '---')
          }
        },
        { title: '操作', align: 'center', width: 150,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.key)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    getNamespaceLabel(namespace) {
      for (var index in this.namespaceOptions) {
        if (this.namespaceOptions[index].value === namespace) {
          return this.namespaceOptions[index].label
        }
      }
      return namespace
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showDelModalDialog: function(id, key) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除数据字典么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, key)])
        },
        onOk: function() {
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '数据字典 `' + key + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '数据字典 `' + key + '` 删除失败, 错误信息: ' + error
            })
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>

